module.exports = __webpack_public_path__ + "img/mixed-logo.bda68e3.gif";